import React from 'react';
import 'twin.macro';
import { useStaticQuery, graphql } from 'gatsby';

import { Container } from '../atoms';
import { Information } from '../elements';
import ServiceCard from './ServiceCard';

const query = graphql`
  query featuredServicesQuery {
    allSanityService(filter: { isFeatured: { eq: true } }) {
      nodes {
        _id
        title
        slug {
          current
        }
        seoFeaturedImage {
          asset {
            gatsbyImageData
          }
        }
        description
        isFeatured
      }
    }
  }
`;

const FeaturedProduct = ({ title, description }) => {
  const { allSanityService } = useStaticQuery(query);
  const data = allSanityService.nodes;

  return (
    <Container tw="bg-slate">
      <div tw="py-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-6 ">
        <Information
          heading={title}
          description={description}
          to="/"
          buttonText="SEE ALL SERVICES"
        />
        {data.map((item) => (
          <ServiceCard data={item} key={item._id} />
        ))}
      </div>
    </Container>
  );
};

export default FeaturedProduct;
